<template>
  <a-modal
      title="添加链接"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="submit"
      @cancel="visible = false"
      :afterClose="afterClose"
      destroyOnClose
  >
    <a-form-model :model="form" ref="ruleForm" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="链接标题" prop="name">
        <a-input :size="$globalSize" v-model="form.name"/>
      </a-form-model-item>
      <a-form-model-item label="链接描述" prop="desc">
        <a-input :size="$globalSize" v-model="form.desc"/>
      </a-form-model-item>
      <a-form-model-item label="跳转地址" prop="address">
        <a-input :size="$globalSize" v-model="form.address"/>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>
<script>
import utils from "@/utils";

export default {
  name: "addLinkModal",
  components: {},
  props: {},

  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 4 : 7
      },
      wrapperCol: {
        span: localStorage.getItem('i18n').startsWith('zh') ? 18 : 17
      },
      form: {
        name:'',
        desc:'',
        address:''
      },
      rules: {
        name: [
          {required: true, message: '请输入链接标题', trigger: 'change'}
        ],
        address: [
          {required: true, message: '请输入跳转地址', trigger: 'change'}
        ],
      }
    };
  },
  mounted() {
    utils.languageChange(this, {labelCol: 8, wrapperCol: 16}, {labelCol: 6, wrapperCol: 16})
  },
  computed: {},
  watch: {},
  methods: {
    showModal() {
      this.visible = true;
    },
    submit() {
      this.$refs.ruleForm.validate(async valid=>{
        if(!valid)return false
        this.$emit('sync',{...this.form,type:'link'})
        this.visible = false
      })
    },
    afterClose() {
    }
  },
};
</script>

<style scoped lang="less">

</style>
